import React from 'react'

import clsx from 'clsx'

import EmptyState from 'components/EmptyState'
import IconText from 'components/IconText'
import Pricing from 'components/Pricing'
import {
  hasOneTimePayment,
  hasPeriodicity,
  hasPerUser,
  hasPricingInfo,
  hasPricingModel,
  pricingModelIcons,
} from 'helpers/pricing'

import icPricetagSVG from 'assets/ic-pricetag.svg'

import styles from './Display.module.scss'

/** @type {import("./types").default} */
const Display = ({ hidePricingModel, pricing = {}, variant = 'large', className }) => {
  const hasPricing = !!pricing.amount

  return (
    <div className={clsx('Display', styles.root, styles[variant], className)}>
      {hasPricingInfo(pricing) ? (
        <>
          <Pricing.Amount pricing={pricing} variant={variant} />
          <>
            {(hasPeriodicity(pricing) || hasOneTimePayment(pricing)) && hasPricing && (
              <IconText
                className={styles.iconText}
                icon={['far', 'calendar']}
                text={hasPeriodicity(pricing) ? `Per ${pricing.periodicity}` : 'One-time payment'}
                variant={variant}
              />
            )}
            {hasPricingModel(pricing) && !hasPerUser(pricing) && !hidePricingModel && hasPricing && (
              <IconText
                className={styles.iconText}
                icon={pricingModelIcons[pricing.pricing_model]}
                text={pricing.pricing_model}
                variant={variant}
              />
            )}
          </>
        </>
      ) : (
        <EmptyState img={icPricetagSVG.src} text="No pricing info" variant={variant} />
      )}
    </div>
  )
}

export default Display
